module.exports = __webpack_public_path__ + "img/lancelot-blanchard.33931868.jpg";